import { render, staticRenderFns } from "./ClassCESButton.vue?vue&type=template&id=6b106b30&"
import script from "./ClassCESButton.vue?vue&type=script&lang=ts&"
export * from "./ClassCESButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports